/** How a proposal item's action reads, wherever a proposal's items are listed: the change set's
 *  page and the proposal review page, where a person applies it. */
import type { AIChangeProposal } from '@/api/aiChanges';

export const ITEM_ACTION: Record<AIChangeProposal['items'][number]['action'], string> = {
  create: 'New',
  update: 'Update',
  delete: 'Delete',
  noop: 'Reuse',
  // A franchise licensee's own copy of its parent's notification (P7; target = the parent's).
  copy: 'Copy to own',
};
